var styles = {"fontElementMap":"p8BXe","orderedlist":"_6zE6t","bulletedlist":"mEoUt","listItem":"S-YMD"};

export { styles as s };
//# sourceMappingURL=lists-09d56ef4.js.map
